import { isSanityLoginLink, isSanityPathLink, isSanityRegistrationLink } from '../lib/sanity/link'
import { SanityMenuEntryProps } from './sanity/documents/menuEntry'

export function isAccountMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return !!firstTarget && isSanityPathLink(firstTarget) && firstTarget.path === '/account'
}

export function isLoginMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return (
    !!firstTarget &&
    ((isSanityPathLink(firstTarget) && firstTarget.path === '/login') ||
      isSanityLoginLink(firstTarget))
  )
}

export function isEScriptMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return !!firstTarget && isSanityPathLink(firstTarget) && firstTarget.path === '/escript/build'
}

export const isInteractionCheckerMenuEntry = (menuEntry: SanityMenuEntryProps): boolean => {
  const [firstTarget] = menuEntry?.link?.target || []
  return (
    !!firstTarget &&
    isSanityPathLink(firstTarget) &&
    firstTarget.path === '/drug-nutrient-interaction'
  )
}

export const isECatalogMenuEntry = (menuEntry: SanityMenuEntryProps): boolean => {
  const { name, link } = menuEntry
  const [firstTarget] = link?.target || []

  return !!firstTarget && name === 'E-Catalog'
}

export function isRegistrationMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return !!firstTarget && isSanityRegistrationLink(firstTarget)
}
